import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Button } from '@mui/material';
import { CSVLink } from "react-csv";
import axios from "axios"
import PurchaseOrderForm from '../components/PurchaseOrderForm.js';
import { Box, IconButton } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PurchaseRec from '../components/PurchaseRec.js';
import company from "../../assets/company.png"
import { useAuth } from '../../AuthContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PurchaseOrderPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);
  const [totalPurchaseOrder, setTotalPurchaseOrder] = useState(0);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])

  const defaultLogoUrl = company;
  // const [companylogo, setCompanyLogo] = useState(defaultLogoUrl);
  let [selectedRow, setSelectedRow] = useState(null);
  let [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  let rowData = {};

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  useEffect(() => {
    const fetchAll_PurchaseOrder = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/purchaseorders/all_purchaseorders`);
        const responseData = await response.json()
        if (responseData) {
          setData(responseData.purchaseorder)
        }
      } catch (error) {
        console.log(error.message);
      }
    }

    fetchAll_PurchaseOrder();

    const calculateTotalPurchaseOrder = () => {
      const PurchaseOrderSum = data && data.reduce((sum, invoice) => sum + Number(invoice.total), 0);
      setTotalPurchaseOrder(PurchaseOrderSum);
    };

    calculateTotalPurchaseOrder();
  }, [showPopup])

  useEffect(() => {

    const calculateTotalPurchaseOrder = () => {
      const PurchaseOrderSum = data && data.reduce((sum, invoice) => sum + Number(invoice.total), 0);
      setTotalPurchaseOrder(PurchaseOrderSum);
    };

    calculateTotalPurchaseOrder();
  }, [data])


  const updateDataAfterDelete = (deletedRowId) => {
    setData((prevData) => {
      const updatedData = prevData.filter((row) => row.invoicenumber !== deletedRowId);
      return updatedData;
    });
  };


  const delete_PurchaseOrder = async (selectedRowId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/purchaseorders/delete_purchaseorder`, {
        data: {
          "purchaseordernumber": selectedRowId
        }
      })
      if (response.status === 200) {
        toast.success(`Purchase order with id: "${selectedRowId}" deleted successfully.`)
        updateDataAfterDelete(selectedRowId)
      }
    } catch (error) {
      toast.error("Error deleting purchase order")
    }
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'purchaseordernumber',
        header: 'Purchase Order No.',
        size: 100,
      },
      {
        accessorKey: 'issuedate',
        header: 'Issue Date',
        size: 100,
      },
      {
        accessorKey: 'time',
        header: 'Time',
        size: 100,
      },
      {
        accessorKey: 'vendor',
        header: 'Vendor',
        size: 100,
      },

      {
        accessorKey: 'vendorlpo',
        header: 'Vendor LPO',
        size: 100,
      },

      {
        accessorKey: 'total',
        header: 'Total',
        size: 100,
      }
    ],
    [],
  );

  return (
    <>
      <StickyTitle title="Purchase Order" button_action={togglePopup} button="New Purchase Order" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        <div>
          {isPopupOpen && (
            <div style={{
              display: isPopupOpen ? 'block' : 'none',
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              padding: '20px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
              zIndex: '999',
              height: '90vh',
              overflowY: 'auto',
              width: '800px'
            }}>

              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                onClick={() => setIsPopupOpen(false)}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <PurchaseRec
                companylogo={defaultLogoUrl}
                vendorname={selectedRowData.vendor}
                vendorlpo={selectedRowData.vendorlpo}
                vendoraddress={selectedRowData.vendoraddress}
                vendorphone={selectedRowData.vendorphone}
                purchaseordernumber={selectedRowData.purchaseordernumber}
                podate={selectedRowData.issuedate}
                time={selectedRowData.time}
                list={selectedRowData.list}
                total={selectedRowData.total}
                notes={selectedRowData.notes}
                discount={selectedRowData.discount}
                deliveryDate={selectedRowData.deliveryDate}
              />

            </div>
          )}
        </div>

        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
          <div className='text-2xl ml-2 font-bold font-poppins'>All Purchase Order</div>
          <h2 className=' text-end text-sm sm:text-xl text-black'> Total For All Purchase Order:<span className='ml-1 text-lg md:text-2xl font-bold'>{`QAR ${totalPurchaseOrder} `}</span></h2>
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns}
            data={data}
            renderRowActions={({ row }) => (
              <Box>
                <IconButton onClick={() => {
                  rowData = row.original;
                  setSelectedRowData(rowData)
                  setIsPopupOpen(true);
                }}>
                  <ReceiptIcon />
                </IconButton>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.purchaseordernumber;
                  setSelectedRow(selectedRow);
                  alert('Deleting PurchaseOrder with ID: ' + selectedRowId);
                  delete_PurchaseOrder(selectedRowId)
                } else {
                  alert('Please select a single row to delete.');
                }
              };

              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}
                  >
                    Delete
                  </Button>

                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>) : (null)}

        {showPopup && (
          <div className="fixed bg-white inset-0 flex items-center overflow-y-auto justify-center z-50">
            <div className="bg-white rounded-lg p-4 shadow-md ">
              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                onClick={togglePopup}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <div style={{
                height: '90vh',
                overflowY: 'auto',
              }}>
                <PurchaseOrderForm handleChild={togglePopup} />
              </div>
            </div>
          </div >
        )}
      </div>



    </>
  );
};

export default PurchaseOrderPage;
